var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H38C43.5229 0 48 4.47715 48 10V38C48 43.5229 43.5228 48 38 48H10C4.47715 48 0 43.5228 0 38V10Z",
    fill: "#0061D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0002 34.5L23.8834 34.3249C23.073 33.1093 22.6678 32.5015 22.1324 32.0615C21.6585 31.6719 21.1124 31.3796 20.5254 31.2014C19.8623 31 19.1318 31 17.6708 31H16.0668C14.76 31 14.1066 31 13.6075 30.7457C13.1685 30.522 12.8115 30.165 12.5878 29.726C12.3335 29.2269 12.3335 28.5735 12.3335 27.2667V17.2333C12.3335 15.9265 12.3335 15.2731 12.5878 14.774C12.8115 14.335 13.1685 13.978 13.6075 13.7543C14.1066 13.5 14.76 13.5 16.0668 13.5H16.5335C19.1471 13.5 20.4539 13.5 21.4521 14.0086C22.3302 14.456 23.0441 15.17 23.4915 16.048C24.0002 17.0463 24.0002 18.3531 24.0002 20.9667M24.0002 34.5V20.9667M24.0002 34.5L24.1169 34.3249C24.9273 33.1093 25.3325 32.5015 25.8679 32.0615C26.3418 31.6719 26.8879 31.3796 27.475 31.2014C28.138 31 28.8685 31 30.3295 31H31.9335C33.2403 31 33.8937 31 34.3928 30.7457C34.8319 30.522 35.1888 30.165 35.4125 29.726C35.6668 29.2269 35.6668 28.5735 35.6668 27.2667V17.2333C35.6668 15.9265 35.6668 15.2731 35.4125 14.774C35.1888 14.335 34.8319 13.978 34.3928 13.7543C33.8937 13.5 33.2403 13.5 31.9335 13.5H31.4668C28.8533 13.5 27.5465 13.5 26.5482 14.0086C25.6701 14.456 24.9562 15.17 24.5088 16.048C24.0002 17.0463 24.0002 18.3531 24.0002 20.9667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.67357b72c5ea9dd53b2d3e3817018968.svg";
export { ForwardRef as ReactComponent };